import PhoneInput from 'react-phone-input-2';
import styled from 'styled-components';
import { COLOR, type ColorMode, fieldBorderRadius, FONT_SIZE, INPUT_COLORS } from '../../styles';
import './high-res.css';

// Bug in vite, fixed in 4.4.9 https://github.com/bl00mber/react-phone-input-2/issues/599, https://github.com/vitejs/vite/issues/2139#issuecomment-1704391126
// I am not updating vite, at this time, as it would be a breaking change
const Input = ((PhoneInput as any).default || PhoneInput) as typeof PhoneInput;

export const PhoneInputStyled = styled(Input)<{ colorMode: ColorMode }>`
  position: relative;

  .form-control {
    /* Space on the left for the flag menu */
    padding-left: 60px;
    opacity: 100;
    font-size: 14px;
    /* Pin to the same 34px height as Input's ClearButton so the text and
       clear-button portions of the field stay flush. */
    line-height: 18px;
    height: 34px;
    box-sizing: border-box;
  }
  .flag-dropdown {
    position: absolute;
    top: 0;
    bottom: 0;
    cursor: pointer;
  }
  input[disabled] {
    & + .flag-dropdown {
      .selected-flag {
        background-color: transparent;
      }
      .arrow {
        display: none;
      }
      cursor: not-allowed;
    }
  }
  .selected-flag {
    outline: none;
    position: relative;
    width: 49px;
    height: 100%;
    padding-left: 8px;
    background-color: ${({ colorMode }) => colorMode === 'light' && ' #0000000a'};
    &:hover,
    &:focus,
    &.open {
      /* Transparent black color */
      background-color: #00000040;
    }
    .flag {
      position: absolute;
      top: 50%;
      margin-top: -12px;
    }
    .arrow {
      position: relative;
      top: 50%;
      margin-top: -1px;
      left: 30px;
      width: 0;
      height: 0;
      border-left: 3px solid transparent;
      border-right: 3px solid transparent;
      border-top: 4px solid ${COLOR['primary']};
      &.up {
        border-top: none;
        border-bottom: 4px solid ${COLOR['primary']};
      }
    }
  }
  .country-list {
    z-index: 2000;
    outline: none;
    list-style: none;
    position: absolute;
    padding: 0;
    margin: 0;
    background: ${({ colorMode }) =>
      // Make the japan flag visible in the dropdown by having a slight background color
      colorMode === 'light' ? COLOR['light-gray-lightest'] : INPUT_COLORS[colorMode].background};
    border: 1px solid ${COLOR['primary']};
    border-radius: ${fieldBorderRadius};
    transform: translateY(2px);
    width: 300px;
    height: auto;
    max-height: 300px;
    overflow-y: auto;

    .country {
      font-size: ${FONT_SIZE['13']};
      display: flex;
      gap: 8px;
      align-items: center;
      padding: 5px 10px;
      &:hover,
      &:focus {
        background: ${COLOR['primary']};
        color: ${COLOR['white']};
        outline: none;
      }
      .flag {
        margin-top: -4px;
      }
      .dial-code {
        color: ${COLOR['light-gray']};
      }
    }
  }
  .special-label {
    display: none;
  }
  .divider {
    padding-bottom: 5px;
    margin-bottom: 5px;
    border-bottom: 1px solid ${COLOR['fieldBorderColor']};
  }
`;
